var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{ref:_vm.iconRef,staticClass:"iconify",style:({
      'font-size': _vm.size,
      'color': _vm.disabled ? _vm.disabledColor : _vm.color
    }),attrs:{"data-icon":_vm.icon}})
}
var staticRenderFns = []

export { render, staticRenderFns }